import styled from 'styled-components';
import { Box, Paper } from '@mui/material';
import { colors } from 'spw-theme';
import { Column, Row } from './grid';

export const SPWContainerHeader = styled(Box)`
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const SPWSpaceAroundBox = styled(Row)`
  justify-content: space-around;
`;

export const SPWSpaceBetweenBox = styled(Row)`
  justify-content: space-between;
`;

export const ContainerLeftText = styled(Box)`
  flex: initial;
  flex-grow: 1;
  flex-basis: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height, or 140% */
  color: #000000;
`;

export const HeaderRightButtonContainer = styled(Box)`
  flex-grow: 1;
  flex-basis: 0;
  text-align: right;
`;

export const BoxPaper = styled(Paper)`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  /* shadow-25px */

  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.21);
  border-radius: 5px;
`;

export const InformationContainerBox = styled(Column)`
  padding-top: 10px;

  &.empty * {
    color: ${colors.emptyField} !important;
  }
`;

export const InformationContainerTitle = styled(Row)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  letter-spacing: 0.4px;

  color: #616161;

  &.empty {
    color: ${colors.emptyField} !important;
  }
`;
export const InformationContainerValue = styled(Row)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  color: #000000;

  &.empty {
    color: ${colors.emptyField} !important;
  }
`;

export const MarginLeft8 = styled.div`
  margin-left: 8px;
`;

export const MarginBottom16 = styled.div`
  margin-bottom: 16px;
`;

export const MarginBottom8 = styled.div`
  margin-bottom: 8px;
`;

export const SpaceTypeLabel = styled.div`
  margin-left: 4px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 133% */
  letter-spacing: 0.25px;
`;

export const MarginTop8 = styled.div`
  margin-top: 8px;
`;

export const MarginTop16 = styled.div`
  margin-top: 16px;
`;

export const MarginLeft4 = styled.div`
  margin-left: 4px;
`;

export const MarginTop4 = styled.div`
  margin-top: 4px;
`;
